import { keyframes } from '@emotion/react'
import { animation, AnimationOptions } from '../../utils/animation'

const progressAnimationKeyframes = keyframes`
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
`

export const getAnimation =
  (animationName: string = progressAnimationKeyframes) =>
  (opts: AnimationOptions) =>
    animation(animationName)(opts)
